import React, { useRef, useEffect, useState } from "react";

export default function Countdown() {
  const [num, setNum] = useState(80);
  
  let intervalRef = useRef();
  let cls = 'loader';

  const decreaseNum = () => setNum((prev) =>{
    let num = prev - 1;
    
    if(num < 0) {
        return 0;
    };

    return num;
});

useEffect(() => {
  intervalRef.current = setInterval(decreaseNum, 1000);

    return () => clearInterval(intervalRef.current);
  }, []);
  
  cls += (num === 0 ? ' loader--finish' : '');

  return (
    <div>
      <div>
        <span class={cls}>
          <div class="loader-circle"></div>
          <div class="loader-text">
            <div class="loader-text--sec">
              {num}
            </div>
            <div class="loader-text--desc">
              seconds
            </div>
          </div>
        </span>
      </div>
    </div>
  );
}